// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"index_mobileMenu_xxXzI","handler":"index_handler_2W-Ya","handlerIcon":"index_handlerIcon_1NeDf"};